import _regeneratorRuntime from 'babel-runtime/regenerator';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import { fork, call, cancel, cancelled, take, takeEvery, takeLatest } from 'redux-saga/effects';

export function createSaga(logic, input) {
  var useLegacyUnboundActions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var sagaWrap = useLegacyUnboundActions ? function (func) {
    return function () {
      var legacyLogic = _Object$assign({}, logic, { actionCreators: undefined, actions: logic.actionCreators });
      return func.bind(legacyLogic).apply(undefined, arguments);
    };
  } : function (func) {
    return func.bind(logic);
  };

  var sagaExec = useLegacyUnboundActions ? function (func) {
    var legacyLogic = _Object$assign({}, logic, { actionCreators: undefined, actions: logic.actionCreators });
    return func(legacyLogic);
  } : function (func) {
    return func(logic);
  };

  // bind workers and save to logic
  if (input.workers) {
    if (!logic.workers) {
      logic.workers = {};
    }

    for (var _iterator = _Object$keys(input.workers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var key = _ref;

      if (typeof input.workers[key] === 'function') {
        logic.workers[key] = sagaWrap(input.workers[key]);
      }
    }
  }

  // generate the saga
  var saga = _regeneratorRuntime.mark(function saga() {
    var workers, ops, _iterator2, _isArray2, _i2, _ref2, op, list, keys, i, fn, actionKey, j, _iterator3, _isArray3, _i3, _ref3, _saga, _iterator4, _isArray4, _i4, _ref4, _saga2;

    return _regeneratorRuntime.wrap(function saga$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            workers = [];
            _context.prev = 1;

            // start takeEvery and takeLatest watchers
            ops = { takeEvery: takeEvery, takeLatest: takeLatest };
            _iterator2 = _Object$keys(ops), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);

          case 4:
            if (!_isArray2) {
              _context.next = 10;
              break;
            }

            if (!(_i2 >= _iterator2.length)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('break', 39);

          case 7:
            _ref2 = _iterator2[_i2++];
            _context.next = 14;
            break;

          case 10:
            _i2 = _iterator2.next();

            if (!_i2.done) {
              _context.next = 13;
              break;
            }

            return _context.abrupt('break', 39);

          case 13:
            _ref2 = _i2.value;

          case 14:
            op = _ref2;

            if (!input[op]) {
              _context.next = 37;
              break;
            }

            list = sagaExec(input[op]);
            keys = _Object$keys(list);
            i = 0;

          case 19:
            if (!(i < keys.length)) {
              _context.next = 37;
              break;
            }

            fn = list[keys[i]];
            actionKey = logic.actions[keys[i]] ? logic.actions[keys[i]].toString() : keys[i];

            if (!Array.isArray(fn)) {
              _context.next = 32;
              break;
            }

            j = 0;

          case 24:
            if (!(j < fn.length)) {
              _context.next = 30;
              break;
            }

            _context.next = 27;
            return ops[op](actionKey, sagaWrap(fn[j]));

          case 27:
            j++;
            _context.next = 24;
            break;

          case 30:
            _context.next = 34;
            break;

          case 32:
            _context.next = 34;
            return ops[op](actionKey, sagaWrap(fn));

          case 34:
            i++;
            _context.next = 19;
            break;

          case 37:
            _context.next = 4;
            break;

          case 39:
            if (!logic.connectedSagas) {
              _context.next = 59;
              break;
            }

            _iterator3 = logic.connectedSagas, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);

          case 41:
            if (!_isArray3) {
              _context.next = 47;
              break;
            }

            if (!(_i3 >= _iterator3.length)) {
              _context.next = 44;
              break;
            }

            return _context.abrupt('break', 59);

          case 44:
            _ref3 = _iterator3[_i3++];
            _context.next = 51;
            break;

          case 47:
            _i3 = _iterator3.next();

            if (!_i3.done) {
              _context.next = 50;
              break;
            }

            return _context.abrupt('break', 59);

          case 50:
            _ref3 = _i3.value;

          case 51:
            _saga = _ref3;
            _context.t0 = workers;
            _context.next = 55;
            return fork(_saga);

          case 55:
            _context.t1 = _context.sent;

            _context.t0.push.call(_context.t0, _context.t1);

          case 57:
            _context.next = 41;
            break;

          case 59:
            if (!input.start) {
              _context.next = 62;
              break;
            }

            _context.next = 62;
            return call(sagaWrap(input.start));

          case 62:
            if (!(input.stop || logic.connectedSagas)) {
              _context.next = 68;
              break;
            }

          case 63:
            if (!true) {
              _context.next = 68;
              break;
            }

            _context.next = 66;
            return take('wait until worker cancellation');

          case 66:
            _context.next = 63;
            break;

          case 68:
            _context.prev = 68;
            _context.next = 71;
            return cancelled();

          case 71:
            if (!_context.sent) {
              _context.next = 92;
              break;
            }

            if (!input.stop) {
              _context.next = 75;
              break;
            }

            _context.next = 75;
            return call(sagaWrap(input.stop));

          case 75:
            if (!logic.connectedSagas) {
              _context.next = 92;
              break;
            }

            _iterator4 = workers, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);

          case 77:
            if (!_isArray4) {
              _context.next = 83;
              break;
            }

            if (!(_i4 >= _iterator4.length)) {
              _context.next = 80;
              break;
            }

            return _context.abrupt('break', 92);

          case 80:
            _ref4 = _iterator4[_i4++];
            _context.next = 87;
            break;

          case 83:
            _i4 = _iterator4.next();

            if (!_i4.done) {
              _context.next = 86;
              break;
            }

            return _context.abrupt('break', 92);

          case 86:
            _ref4 = _i4.value;

          case 87:
            _saga2 = _ref4;
            _context.next = 90;
            return cancel(_saga2);

          case 90:
            _context.next = 77;
            break;

          case 92:
            return _context.finish(68);

          case 93:
          case 'end':
            return _context.stop();
        }
      }
    }, saga, this, [[1,, 68, 93]]);
  });

  if (logic.saga) {
    var oldSaga = logic.saga;
    logic.saga = _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fork(oldSaga);

            case 2:
              _context2.next = 4;
              return fork(saga);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee, this);
    });
  } else {
    logic.saga = saga;
  }
}